import { ExchangeSymbolType } from "trade_utils_lib";
import { SymbolMap } from "./SymbolMap";
export var EmptyExchangeSymbolDataItem = {
  symbolType: ExchangeSymbolType.unknown,
  symbols: [],
  map: new SymbolMap(),
  quotes: []
};
export var EmptyExchangeSymbolData = {
  allSymbols: [],
  spotSymbolData: {
    symbolType: ExchangeSymbolType.spot,
    symbols: [],
    map: new SymbolMap(),
    quotes: []
  },
  swapBSymbolData: {
    symbolType: ExchangeSymbolType.swap_binance,
    symbols: [],
    map: new SymbolMap(),
    quotes: []
  },
  futurePSymbolData: {
    symbolType: ExchangeSymbolType.future_perpetual,
    symbols: [],
    map: new SymbolMap(),
    quotes: []
  },
  symbolMap: new SymbolMap()
};